import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrHouseRuleAllowed.ts
var t = () => e("houseRuleAllowed");
//#endregion
export { t as useTrHouseRuleAllowed };
